export const handleFirestoreError = (elm, refPath, err) => {
  if (err.code == "internal") {
    elm.ports.refreshApp.send(`${refPath} onSnapshot error. ${err.code}:${err.message}`);
  }
};
